import React from 'react'
import injectSheet from 'react-jss'
import styles from './comments-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import CommentEntry from './comment-entry/comment-entry.container'
import { Pagination } from 'pobble-components/dist/pagination'

const CommentsTable = ({
  classes,
  comments,
  on,
  noComments,
  pagination,
  onPageChange,
  pending
}) => {
  return noComments ? (
    <span>This pupil doesn't have any comments yet</span>
  ) : (
    <div className={classes.container}>
      <Table pending={pending}>
        <thead>
          <tr>
            <HeadCell className={classes.left}>Date</HeadCell>
            <HeadCell className={classes.left}>Comment</HeadCell>
            <HeadCell>Status</HeadCell>
            <HeadCell className={classes.contextMenuCell} />
          </tr>
        </thead>
        <tbody>
          {comments.map(comment => (
            <CommentEntry id={comment.id} />
          ))}
        </tbody>
      </Table>
      <div className={classes.pagination}>
        <Pagination onPageChange={onPageChange} data={pagination} />
      </div>
    </div>
  )
}

export default injectSheet(styles)(CommentsTable)
